import { useQuery } from "@jti/rest-api";

import { magento } from "../clients/getClient";
import type { IGetOrderStatusesQuery } from "../types/CodegenTypes";

type OrderStatuses = {
  data: IGetOrderStatusesQuery | undefined;
  isLoading: boolean;
};

export const useOrderStatuses = (): OrderStatuses => {
  const { data, isLoading } = useQuery<IGetOrderStatusesQuery, { errors: { message: string }[] }>(
    "getOrderStatuses",
    () => magento.getOrderStatuses()
  );
  return { data, isLoading };
};
